// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__TBMs0","loader":"Spinner_loader__RVUW5","spin":"Spinner_spin__tiwVl","scaling":"Spinner_scaling__XEok6"};